import React from 'react';
import {
    Home, Users, Briefcase, Settings, ChevronLeft, ChevronRight, MoreVertical,
    PlusCircle, Search, Bell, Menu, Sun, Moon, LogOut, User, UserCircle, Loader2, Mail,
    Server, X, Edit, Trash2, Package, BrainCircuit, LayoutGrid, Library, Database,
    Bot, Share2, ShieldCheck, Layers, Layers2, Lock, Palette, Type, Save, RotateCcw, Component, Check,
    BadgeDollarSign, FilePlus, FolderPlus, RefreshCw, CableIcon, Play, AppWindow, UserCog,
    LayoutDashboard, BarChart3, Cpu, Maximize, Box,
    // IDE Icons
    ChevronDown, FileText, FileCode, Upload, SaveAll, Minimize, Terminal, Copy, Command as CommandIcon,
    GitBranch, Files, Rocket, Calendar, Beaker, BellRing,
    // Added for UI Sync
    History, Eye, EyeOff, Globe, Brain, Activity,
    // Export/Import
    FileJson, FileSpreadsheet, FileUp, FileDown,
    Share, FolderInput,
    // Trends & Missing
    ArrowUp, ArrowDown, Minus, PlayCircle, TrendingUp, TrendingDown,
    // Sidebar
    PanelLeftClose, PanelLeftOpen, Workflow, Group, PackageCheck, DatabaseBackup, Factory, ChartPie, Loader,
    // Misc
    List, Zap,
    // SKB / General UI additions
    ArrowLeft, Pencil, Plus, Download, AlertTriangle, AlertCircle, CheckCircle,
    Tag, Sparkles, Table, BookOpen, CircleDot
} from 'lucide-react';

export const ICONS = {
    Home, Users, Briefcase, Settings, ChevronLeft, ChevronRight, MoreVertical,
    PlusCircle, Search, Bell, Menu, Sun, Moon, LogOut, User, UserCircle, Loader2, Mail,
    Server, X, Edit, Trash2, Package, BrainCircuit, LayoutGrid, Library, Database,
    Bot, Share2, ShieldCheck, Layers, Layers2, Lock, Palette, Type, Save, RotateCcw, Component, Check, BadgeDollarSign,
    FilePlus, FolderPlus, RefreshCw, CableIcon, Play, AppWindow, UserCog,
    LayoutDashboard, BarChart3, Cpu, Maximize, Box,
    // IDE Icons
    ChevronDown, FileText, FileCode, Upload, SaveAll, Minimize, Terminal, Copy, Command: CommandIcon,
    GitBranch, Files, Rocket, Calendar, Beaker, BellRing,
    // Added for UI Sync
    History, Eye, EyeOff, Globe, Brain, Activity,
    // Export/Import
    FileJson, FileSpreadsheet, FileUp, FileDown,
    Share, FolderInput,
    // Trends & Missing
    ArrowUp, ArrowDown, Minus, PlayCircle, TrendingUp, TrendingDown,
    // Sidebar
    PanelLeftClose, PanelLeftOpen, Workflow, Group, PackageCheck, DatabaseBackup, Factory, ChartPie, Loader,
    // Misc
    List, Zap,
    // SKB / General UI additions
    ArrowLeft, Pencil, Plus, Download, AlertTriangle, AlertCircle, CheckCircle,
    Tag, Sparkles, Table, BookOpen, CircleDot
};

export const DynamicIcon = ({ name, className = "w-5 h-5" }) => {
    const Icon = ICONS[name];
    return Icon ? <Icon className={className} /> : <Package className={className} />;
};